module.exports = __webpack_public_path__ + "img/confirmedUpdate.64f04977.svg";